import { inject, Pipe, PipeTransform } from '@angular/core';
import { RemoteConfigBooleanKey } from '@marmon/shared/types/config';
import { ConfigService } from '../services';

@Pipe({ name: 'configBoolean' })
export class ConfigBooleanPipe implements PipeTransform {
	readonly config = inject(ConfigService);

	transform(key: RemoteConfigBooleanKey) {
		return this.config.getBoolean(key as RemoteConfigBooleanKey);
	}
}
